import React from 'react';

import { useTranslation } from 'react-i18next';

import { LegacyCheckPurpleSmallIcon } from '@pkg/assets/icons/deprecated';
import { ReactComponent as RightIcon } from '@pkg/assets/icons/v2/right.svg';
import { useAppSelector } from '@pkg/hooks';

import { AuthenticatorType } from '../../types';

import './Step.scss';

interface AuthChooseTypeProps {
    onChooseType: (type: AuthenticatorType) => void;
}

export const AuthChooseType = ({ onChooseType }: AuthChooseTypeProps) => {
    const { t } = useTranslation(['twoFactorAuth']);
    const authUser = useAppSelector((rootState) => rootState.user);

    return (
        <>
            <h2
                className="two-factor-auth-step__title"
                dangerouslySetInnerHTML={{ __html: t('2fa_step_choose_title') }}
            />
            <div className="two-factor-auth-step__content">
                {authUser?.userClass?.isAdmin && (
                    <div
                        className="two-factor-auth-step__option"
                        onClick={() => onChooseType(AuthenticatorType.PhoneNumber)}
                    >
                        <div className="content">
                            <h2 className="content__label">
                                {t('2fa_step_choose_text_message_cta')}
                                <span className="icon">
                                    <span className="check">
                                        <LegacyCheckPurpleSmallIcon />
                                    </span>{' '}
                                    {t('2fa_step_choose_text_message_label')}
                                </span>
                            </h2>
                            <p className="content__text">{t('2fa_step_choose_text_message_detail')}</p>
                        </div>
                        <div className="icon">
                            <RightIcon />
                        </div>
                    </div>
                )}
                <div
                    className="two-factor-auth-step__option"
                    onClick={() => onChooseType(AuthenticatorType.AuthenticatorApp)}
                >
                    <div className="content">
                        <h2 className="content__label">{t('2fa_step_choose_authenticator_cta')}</h2>
                        <p className="content__text">{t('2fa_step_choose_authenticator_detail')}</p>
                    </div>
                    <div className="icon">
                        <RightIcon />
                    </div>
                </div>
            </div>
        </>
    );
};
